/**
 * person-content.js
 * アンバサダー/人物コンテンツページの動画機能
 * - 動画オートプレイ（IntersectionObserver）
 * - 動画モーダル
 * - スティッキー動画カラム
 */
document.addEventListener('DOMContentLoaded', function() {
  // autoplay
  var videos = document.querySelectorAll('.amb-video[data-amb-autoplay]');
  var playObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) { entry.target.play(); }
      else { entry.target.pause(); }
    });
  }, { threshold: 0.3 });
  videos.forEach(function(v) { playObserver.observe(v); });

  // モーダルHTML
  var modalHTML = '<div class="amb-video-modal" id="ambVideoModal">'
    + '<div class="amb-video-modal__content">'
    + '<button class="amb-video-modal__close" aria-label="閉じる">✕</button>'
    + '<div class="amb-video-modal__video-wrap">'
    + '<video class="amb-video-modal__video" autoplay loop playsinline></video>'
    + '<button class="amb-video-modal__mute" aria-label="音声切り替え">'
    + '<svg class="muted-icon" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06m7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0"/></svg>'
    + '<svg class="unmuted-icon" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" style="display:none;"><path d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z"/><path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z"/><path d="M8.707 11.182A4.5 4.5 0 0 0 10.025 8a4.5 4.5 0 0 0-1.318-3.182L8 5.525A3.5 3.5 0 0 1 9.025 8 3.5 3.5 0 0 1 8 10.475zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06"/></svg>'
    + '</button>'
    + '<a href="#" class="amb-video-modal__product" style="display:none;">'
    + '<img src="" alt="" class="amb-video-modal__product-img">'
    + '<div class="amb-video-modal__product-body">'
    + '<p class="amb-video-modal__product-title"></p>'
    + '<p class="amb-video-modal__product-price"></p>'
    + '</div>'
    + '</a>'
    + '</div>'
    + '</div>'
    + '</div>';

  if (!document.getElementById('ambVideoModal')) {
    document.body.insertAdjacentHTML('beforeend', modalHTML);
  }

  var modal = document.getElementById('ambVideoModal');
  if (!modal) return;
  var modalVideo = modal.querySelector('.amb-video-modal__video');
  var closeBtn = modal.querySelector('.amb-video-modal__close');
  var muteBtn = modal.querySelector('.amb-video-modal__mute');

  function openAmbModal(sourceVideo, wrap) {
    modalVideo.innerHTML = '';
    sourceVideo.querySelectorAll('source').forEach(function(s) {
      var src = document.createElement('source');
      src.src = s.src; src.type = s.type;
      modalVideo.appendChild(src);
    });
    modalVideo.muted = false;
    modalVideo.load();
    modalVideo.play().catch(function() { modalVideo.muted = true; modalVideo.play(); });
    updateMuteIcon();

    var productEl = modal.querySelector('.amb-video-modal__product');
    var url = wrap && wrap.dataset.productUrl;
    if (url) {
      productEl.href = url;
      productEl.querySelector('.amb-video-modal__product-img').src = wrap.dataset.productImage || '';
      productEl.querySelector('.amb-video-modal__product-img').alt = wrap.dataset.productTitle || '';
      productEl.querySelector('.amb-video-modal__product-title').textContent = wrap.dataset.productTitle || '';
      productEl.querySelector('.amb-video-modal__product-price').textContent = wrap.dataset.productPrice || '';
      productEl.style.display = '';
    } else { productEl.style.display = 'none'; }

    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeAmbModal() {
    modal.classList.remove('active'); document.body.style.overflow = '';
    modalVideo.pause(); modalVideo.innerHTML = '';
  }

  function updateMuteIcon() {
    var mutedIcon = muteBtn.querySelector('.muted-icon');
    var unmutedIcon = muteBtn.querySelector('.unmuted-icon');
    if (modalVideo.muted) { mutedIcon.style.display = 'block'; unmutedIcon.style.display = 'none'; }
    else { mutedIcon.style.display = 'none'; unmutedIcon.style.display = 'block'; }
  }

  muteBtn.addEventListener('click', function(e) { e.stopPropagation(); modalVideo.muted = !modalVideo.muted; updateMuteIcon(); });
  closeBtn.addEventListener('click', function(e) { e.stopPropagation(); closeAmbModal(); });
  modal.addEventListener('click', function(e) { if (e.target === modal) closeAmbModal(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && modal.classList.contains('active')) closeAmbModal(); });

  document.querySelectorAll('.amb-video__wrap').forEach(function(wrap) {
    wrap.addEventListener('click', function() {
      var vid = wrap.querySelector('.amb-video');
      if (vid) openAmbModal(vid, wrap);
    });
  });

  // スティッキー動画カラム (PC only)
  if (window.innerWidth < 900) return;
  var col = document.querySelector('.amb-content__video-col');
  var sticky = document.querySelector('.amb-video-sticky');
  var contentWrap = document.querySelector('.amb-content-wrap');
  if (!col || !sticky || !contentWrap) return;

  function onScroll() {
    if (window.innerWidth < 900) return;
    var colRect = col.getBoundingClientRect();
    var wrapRect = contentWrap.getBoundingClientRect();
    var stickyH = sticky.offsetHeight;
    var offset = 100;
    if (colRect.top <= offset && wrapRect.bottom >= offset + stickyH + 20) {
      sticky.style.position = 'fixed'; sticky.style.top = offset + 'px';
      sticky.style.width = col.offsetWidth + 'px'; col.style.minHeight = stickyH + 'px';
    } else if (wrapRect.bottom < offset + stickyH + 20) {
      sticky.style.position = 'absolute'; sticky.style.top = 'auto';
      sticky.style.bottom = '0'; sticky.style.width = ''; col.style.position = 'relative';
    } else { sticky.style.position = ''; sticky.style.top = ''; sticky.style.width = ''; }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
});
